import { alpha, type SxProps, type Theme } from "@mui/material/styles";

import { encampBrandColors } from "../colors";

export type ScoutTier = "pro" | "regulatory-advisor";

export const SCOUT_TIER_CHIP_STYLES: Record<ScoutTier, { label: string; color: string }> = {
  pro: {
    label: "Pro",
    color: encampBrandColors.sapphire,
  },
  "regulatory-advisor": {
    label: "Regulatory Advisor",
    color: encampBrandColors.pumpkin,
  },
};

/** Shared chip chrome for Scout tier affordances (header badge + Pro CTAs). */
export function getScoutTierChipSx(tier: ScoutTier): SxProps<Theme> {
  const { color } = SCOUT_TIER_CHIP_STYLES[tier];

  return {
    color,
    borderColor: color,
    bgcolor: alpha(color, 0.08),
    height: 24,
    flexShrink: 0,
    "& .MuiChip-label": {
      px: 1,
    },
  };
}
